<template>
    <div class="consume-page">
        <!-- 时间查询区域 -->
        <div class="search-bar">
            <el-date-picker v-model="startTime" type="date" placeholder="选择开始时间"
                style="width: 150px; margin-right: 10px;" value-format="yyyy-MM-dd"></el-date-picker>
            <el-date-picker v-model="endTime" type="date" placeholder="选择结束时间" style="width: 150px; margin-right: 10px;"
                value-format="yyyy-MM-dd"></el-date-picker>
            <el-button type="primary" @click="handleQuery" :loading="queryLoading">查询</el-button>
            <el-button @click="resetQuery" style="margin-left: 10px;">重置</el-button>
        </div>

        <!-- 消费列表表格 -->
        <el-table :data="consumeList" border style="width: 100%; margin-top: 20px;"
            :header-cell-style="{ background: '#f5f7fa', color: '#333' }" v-loading="tableLoading" empty-text="暂无消费记录数据"
            height="70vh">
            <el-table-column prop="consumptionUserId" label="消费人编号" min-width="100"></el-table-column>
            <el-table-column prop="consumptionUserName" label="消费人姓名" min-width="120"></el-table-column>
            <el-table-column prop="personAccount" label="个人账户消费金额" min-width="140">

            </el-table-column>
            <el-table-column prop="subsidyAccount" label="补贴账户消费金额" min-width="140">

            </el-table-column>
            <el-table-column prop="consumptionTime" label="消费时间" min-width="180"></el-table-column>
            <el-table-column prop="consumptionNumber" label="消费流水号" min-width="280">

            </el-table-column>
            <el-table-column prop="consumptionTypeName" label="消费类型名称" min-width="120"></el-table-column>
            <el-table-column prop="merchantName" label="商户名称" min-width="120"></el-table-column>
            <el-table-column prop="mainState" label="状态" width="80">
                <template slot-scope="scope">
                    <el-tag :type="getStatusTagType(scope.row.mainState)">
                        {{ scope.row.mainState }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                    <el-button type="warning" size="mini" @click="openDetail(scope.row)">详情</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-container" style="margin-top: 20px; text-align: right;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.totalCount" background
                :disabled="pagination.totalCount === 0"></el-pagination>
        </div>

        <!-- 详情弹窗 -->
        <el-dialog title="消费详情" :visible.sync="dialogVisible" width="500px" :z-index="2000" append-to-body
            :close-on-click-modal="false">
            <el-form label-width="100px" class="detail-form">
                <el-form-item label="消费流水号">
                    <el-input v-model="detailData.consumptionNumber" disabled />
                </el-form-item>
                <el-form-item label="消费人编号">
                    <el-input v-model="detailData.consumptionUserId" disabled />
                </el-form-item>
                <el-form-item label="消费人姓名">
                    <el-input v-model="detailData.consumptionUserName" disabled />
                </el-form-item>
                <el-form-item label="消费时间">
                    <el-input v-model="detailData.consumptionTime" disabled />
                </el-form-item>
                <el-form-item label="消费类型">
                    <el-input v-model="detailData.consumptionTypeName" disabled />
                </el-form-item>
                <el-form-item label="商户名称">
                    <el-input v-model="detailData.merchantName" disabled />
                </el-form-item>
                <el-form-item label="个人账户金额">
                    <el-input :value="`¥${detailData.personAccount?.toFixed(2) || '0.00'}`" disabled />
                </el-form-item>
                <el-form-item label="补贴账户金额">
                    <el-input :value="`¥${detailData.subsidyAccount?.toFixed(2) || '0.00'}`" disabled />
                </el-form-item>
                <el-form-item label="总消费金额">
                    <el-input
                        :value="`¥${(detailData.personAccount + detailData.subsidyAccount)?.toFixed(2) || '0.00'}`"
                        disabled />
                </el-form-item>
                <el-form-item label="菜单名称">
                    <el-input v-model="detailData.menuName" disabled />
                </el-form-item>
                <el-form-item label="菜单价格">
                    <el-input :value="`¥${detailData.menuPrice?.toFixed(2) || '0.00'}`" disabled />
                </el-form-item>
                <el-form-item label="购买数量">
                    <el-input v-model="detailData.menuCount" disabled />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'ConsumeList',
    data() {
        return {
            startTime: '', // 开始时间
            endTime: '', // 结束时间
            queryLoading: false, // 查询按钮加载状态
            tableLoading: false, // 表格加载状态
            consumeList: [], // 消费列表数据
            dialogVisible: false, // 弹窗显隐控制
            detailData: {}, // 详情数据
            // 分页参数
            pagination: {
                currentPage: 1, // 当前页码
                pageSize: 10,   // 每页条数
                totalCount: 0   // 总条数
            }
        };
    },
    created() {
        // 初始化加载第一页数据（默认查询今日数据）
        this.initDefaultDate();
        this.getConsumeList();
    },
    methods: {
        // 初始化默认日期（今日）
        initDefaultDate() {
            const today = new Date();
            this.startTime = this.formatDate(today);
            this.endTime = this.formatDate(today);
        },

        // 日期格式化（yyyy-MM-dd）
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },

        // 获取消费记录列表
        async getConsumeList() {
            this.tableLoading = true;
            try {
                const url = 'https://www.zhongyanzhiye.com:8090/chelmeyAI/openAPI/selectConsumptionLog';

                // 构造请求参数（根据接口要求调整）
                const requestParams = {
                    pageNum: this.pagination.currentPage,
                    pageSize: this.pagination.pageSize,
                    merchantId: 'jbtjbtct001', // 商户ID（根据实际情况调整）
                    startTime: this.startTime,
                    endTime: this.endTime
                };

                // 发送POST请求
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        // 如需Token认证，添加以下配置
                        // 'Authorization': 'Bearer ' + localStorage.getItem('token')
                    },
                    body: JSON.stringify(requestParams)
                });

                if (!response.ok) {
                    throw new Error(`接口请求失败: ${response.status}`);
                }

                const result = await response.json();

                // 处理接口返回数据（假设接口返回格式：{ code: 200, result: { rows: [], total: 0 }, message: '' }）

                this.consumeList = result.result.rows || [];
                this.pagination.totalCount = result.result.total || 0;

                console.log('消费记录数据:', result);

            } catch (error) {
                console.error('获取消费记录失败:', error);
                this.consumeList = [];
                this.pagination.totalCount = 0;
                this.$message.error('加载数据失败，请检查网络或稍后重试');
            } finally {
                this.tableLoading = false;
                this.queryLoading = false;
            }
        },

        // 查询按钮点击事件
        handleQuery() {
            if (!this.startTime || !this.endTime) {
                this.$message.warning('请选择开始时间和结束时间');
                return;
            }

            // 验证时间范围（开始时间不能晚于结束时间）
            if (new Date(this.startTime) > new Date(this.endTime)) {
                this.$message.warning('开始时间不能晚于结束时间');
                return;
            }

            this.queryLoading = true;
            this.pagination.currentPage = 1; // 重置为第一页
            this.getConsumeList();
        },

        // 重置查询条件
        resetQuery() {
            this.initDefaultDate();
            this.pagination.currentPage = 1;
            this.getConsumeList();
        },

        // 每页条数改变
        handleSizeChange(val) {
            this.pagination.pageSize = val;
            this.pagination.currentPage = 1; // 重置页码
            this.getConsumeList();
        },

        // 当前页码改变
        handleCurrentChange(val) {
            this.pagination.currentPage = val;
            this.getConsumeList();
            // 滚动到表格顶部
            window.scrollTo(0, 200);
        },

        // 打开详情弹窗
        openDetail(row) {
            console.log('消费详情:', row);
            // 构造详情数据（如果需要更详细的数据，可在此处调用详情接口）
            this.detailData = {
                ...row,
                // 补充默认值，避免undefined
                menuName: row.menuName || '-',
                menuPrice: row.menuPrice || 0,
                menuCount: row.menuCount || 1,
                personAccount: row.personAccount || 0,
                subsidyAccount: row.subsidyAccount || 0
            };
            this.dialogVisible = true;
        },

        // 根据状态获取标签类型
        getStatusTagType(mainState) {
            switch (mainState) {
                case '已结单':
                    return 'success';
                case '未结单':
                    return 'warning';

                default:
                    return 'info';
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.consume-page {
    padding: 20px;
    background-color: #fff;
    min-height: calc(100vh - 40px);

    .search-bar {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
    }

    // 省略号样式
    .ellipsis {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
        width: 100%;
    }

    // 详情表单样式
    .detail-form {
        .el-form-item {
            margin-bottom: 15px;
        }

        .el-input {
            --el-input-bg-color: #f9f9f9;
            border-color: #e8e8e8;
        }
    }

    // 分页容器样式
    .pagination-container {
        ::v-deep .el-pagination {
            --el-pagination-text-color: #666;
            --el-pagination-button-color: #409eff;
            --el-pagination-button-hover-color: #66b1ff;
        }
    }
}

// 弹窗样式优化
::v-deep .el-dialog {
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

::v-deep .el-dialog__header {
    border-bottom: 1px solid #f0f0f0;
}

::v-deep .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
}

::v-deep .el-dialog__body {
    padding: 20px;
    max-height: 70vh;
    overflow-y: auto;
}

::v-deep .dialog-footer {
    text-align: center;
    padding-top: 10px;
}

// 加载状态样式
::v-deep .el-loading-mask {
    background-color: rgba(255, 255, 255, 0.8);
}

::v-deep .el-loading-spinner {
    top: 45%;
}
</style>